class CartVariantSelect extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    const dataNode = this.querySelector('[data-cart-variant-data]');
    if (!dataNode) return;

    try {
      this.data = JSON.parse(dataNode.textContent);
    } catch (e) {
      return;
    }

    this.selects = Array.from(this.querySelectorAll('select.cart-item__variant-select'));
    this.selects.forEach((select) => {
      select.addEventListener('change', () => this.handleChange());
    });
  }

  getSelectedOptions() {
    return this.selects.map((s) => s.value);
  }

  findMatchingVariant(selectedOptions) {
    return this.data.variants.find((v) =>
      v.options.every((opt, i) => opt === selectedOptions[i])
    );
  }

  handleChange() {
    const selected = this.getSelectedOptions();
    const match = this.findMatchingVariant(selected);

    if (!match) {
      this.revert();
      return;
    }
    if (!match.available) {
      this.revert();
      return;
    }
    if (match.id === this.data.currentVariantId) {
      return;
    }

    this.swapVariant(match.id);
  }

  revert() {
    this.selects.forEach((select, idx) => {
      select.value = this.data.currentOptions[idx];
    });
  }

  setLoading(state) {
    this.selects.forEach((s) => (s.disabled = state));
    const lineRow = this.closest('.cart-item');
    if (!lineRow) return;
    const spinner = lineRow.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !state);
  }

  buildPropertiesPayload() {
    const raw = this.data.currentProperties;
    const payload = {};
    if (!raw) return payload;

    // `item.properties | json` en Liquid serializa como array de pares
    // [["_bundle","true"], ...], no como objeto. Tratarlo como objeto
    // renombraba las propiedades a "0"/"1" y mataba el flag _bundle
    // (se perdía el 15% del bundle). Aceptamos ambas formas.
    const entries = Array.isArray(raw) ? raw : Object.entries(raw);

    entries.forEach((entry) => {
      if (!Array.isArray(entry) || entry.length < 2) return;
      const key = entry[0];
      const val = entry[1];
      if (typeof key !== 'string' || key === '') return;
      if (typeof val !== 'string' || val === '') return;
      payload[key] = val;
    });

    return payload;
  }

  getSectionsToFetch() {
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  async swapVariant(newVariantId) {
    this.setLoading(true);

    const sections = this.getSectionsToFetch();
    const sectionsUrl = window.location.pathname;

    try {
      const removeRes = await fetch(`${routes.cart_change_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: this.data.lineIndex,
          quantity: 0,
        }),
      });
      if (!removeRes.ok) throw new Error('remove failed');

      const addBody = {
        id: newVariantId,
        quantity: this.data.currentQuantity,
        sections,
        sections_url: sectionsUrl,
      };
      const properties = this.buildPropertiesPayload();
      if (Object.keys(properties).length > 0) addBody.properties = properties;

      const addRes = await fetch(`${routes.cart_url}/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(addBody),
      });
      const addJson = await addRes.json();
      if (!addRes.ok || addJson.status) {
        await this.restoreOldLine();
        this.revert();
        this.setLoading(false);
        return;
      }

      // Sections returned in /cart/add.js response (not via separate GET).
      this.applySections(addJson.sections);

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-variant-select',
          variantId: newVariantId,
        });
      }
    } catch (e) {
      this.revert();
      this.setLoading(false);
    }
  }

  async restoreOldLine() {
    try {
      await fetch(`${routes.cart_url}/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: this.data.currentVariantId,
          quantity: this.data.currentQuantity,
          properties: this.buildPropertiesPayload(),
        }),
      });
    } catch (e) {
      /* noop — best-effort restoration */
    }
  }

  applySections(sectionsData) {
    if (!sectionsData) return;

    const cartDrawerWrapper = document.querySelector('cart-drawer');
    if (sectionsData['cart-drawer'] && cartDrawerWrapper) {
      const parsed = new DOMParser().parseFromString(sectionsData['cart-drawer'], 'text/html');
      const newInner = parsed.querySelector('.drawer__inner');
      const currentInner = cartDrawerWrapper.querySelector('.drawer__inner');
      if (newInner && currentInner) {
        currentInner.innerHTML = newInner.innerHTML;
      }
    }

    if (sectionsData['cart-icon-bubble']) {
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        const parsed = new DOMParser().parseFromString(sectionsData['cart-icon-bubble'], 'text/html');
        const newBubble = parsed.querySelector('.shopify-section') || parsed.body.firstElementChild;
        if (newBubble) bubble.innerHTML = newBubble.innerHTML;
      }
    }
  }
}

customElements.define('cart-variant-select', CartVariantSelect);
